<template>
  <div>
    <h1>Zmienne środowiskowe</h1>

    <pre>{{$store.getters.env}}</pre>

    <br>

    <h1>Stan aplikacji</h1>

    <pre>{{$store.state}}</pre>

    <br>

    <h1>Wersja Frontu</h1>

    <pre>{{versionFront}}</pre>

    <br>

    <h1>Wersja Serwera</h1>


    <pre v-if="!serverError">{{versionBack}}</pre>
    <vs-alert v-else color="danger" icon="new_releases" class="m-4">
      <span>{{serverError}}</span>
    </vs-alert>

    <br>
    <h1>Test arrayBuffer (jeśli widzisz [object File], to znaczy, że działa)</h1>
    <pre>{{file}}</pre>

  </div>
</template>

<script>
  import packageJSON from '../../package.json'
  import {version} from '../plugins/express';

  export default {
    name: "Debug",
    async created() {
      console.log("CREATED");
      try {
        this.versionBack = await version()
      } catch (e) {
        console.log(e);
        this.serverError = e.message;
      }
      this.file = new File(['A','B','C'], "", undefined);
      const buffer = await this.file.arrayBuffer()
      console.log("BUFFER");
      console.log(buffer);
    },
    data() {
      return {
        docs: [],
        versionBack: {},
        serverError: "",
        file: {}
      }
    },
    computed: {
      versionFront() {
        return packageJSON;
      }
    },
  }
</script>

<style>
  pre {
    white-space: pre-wrap;
    background: #ffffff;
    color: #1e1871;
    padding: 2em;
    margin: 1em;
    border: 1px solid #1e1871;
    box-shadow: 5px 5px 10px 0 #7db6ce;

  }
</style>
